import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import DatatableExpand from "../../Constants/DatatableExpand";
import { Row, Col, Button, Label, Container, ButtonGroup } from "reactstrap";
import { COLUMNS_GRADES, EXPAND_ROW_GRADE_ACTIVATION } from "../../Constants/DatatableColumns";
import { getGrades, getRegistrationActivation, putPersonStatus } from "../../Constants/Services";
import { IRegistration, IGrades, IGradeSelected } from "./../../Constants/Interfaces";
import {validateTokenStorage} from './../../Constants/Util';

interface IActivationState {
  dataRegistration: IRegistration[];
  dataRegistrationSelected: IRegistration;
  dataGrades: IGrades[];
  dataGradeSelected: IGradeSelected;
  isOpenModalAddRegistration: boolean;
  isOpenModalImport: boolean;
  isOpenModalChange: boolean;
  isOpenModalRemove: boolean;
}

class Activation extends Component<RouteComponentProps<{}>, IActivationState> {
  constructor(props: any) {
    super(props);
    this.state = {
      dataRegistration: [],
      dataRegistrationSelected: {
        per_id: "",
        per_cedula: "",
        per_name: "",
        per_lastname: "",
        per_status: "",
        per_birthday: "",
        reg_id: "",
        reg_new: "",
        reg_complete: "",
      },
      dataGrades: [],
      dataGradeSelected: {
        gr_id: "",
        gr_desc: "",
      },
      isOpenModalAddRegistration: false,
      isOpenModalImport: false,
      isOpenModalChange: false,
      isOpenModalRemove: false,
    };

    this.fetchGrade = this.fetchGrade.bind(this);
    this.fetchRegistration = this.fetchRegistration.bind(this);
  }

  async fetchRegistration({ gr_id, gr_desc }: IGradeSelected) {
    const response = await getRegistrationActivation(gr_id);
    this.setState({
      dataRegistration: response,
      dataGradeSelected: { gr_id, gr_desc },
    });
  }

  async fetchGrade() {
    const response = await getGrades();
    this.setState({
      dataGrades: response,
    });
  }

  componentDidMount() {
    if(validateTokenStorage()){
      this.context.quitToken();
    }
    this.fetchGrade();
  }

  handleChangeStatus(row: IRegistration) {
    const propsGrade = this.state.dataGradeSelected;
    const body = {
      per_id: row.per_id,
      per_status: row.per_status,
    };
    putPersonStatus(body);
    setTimeout(() => {
      this.fetchRegistration({
        gr_id: propsGrade.gr_id,
        gr_desc: propsGrade.gr_desc,
      });
    }, 1000);
  }

  activationHandleOptions = (cell: string, row: IRegistration) => {
    return (
      <Row>
        <Col sm={12} className="text-center m-auto">
          <ButtonGroup>
            <Button outline onClick={() => this.handleChangeStatus(row)} active={row.per_status === "1" ? true : false}>
              ACTIVO
            </Button>
            <Button outline onClick={() => this.handleChangeStatus(row)} active={row.per_status === "0" ? true : false}>
              INACTIVO
            </Button>
          </ButtonGroup>
        </Col>
      </Row>
    );
  };

  render() {
    const props = this.state;
    return (
      <React.Fragment>
        <Container className="mt-4">
          <Row>
            <Col sm={12} className="text-center">
              <Label className="font-weight-bold">
                <h3>Activaciones</h3>
              </Label>
            </Col>
            <Col sm={12} className="text-right mb-3"></Col>
            <Col sm={12}>
              <DatatableExpand
                data={props.dataGrades}
                columns={COLUMNS_GRADES()}
                keyProp="gr_id"
                expandRow={EXPAND_ROW_GRADE_ACTIVATION(this.fetchRegistration, props.dataRegistration, this.activationHandleOptions)}
                exportD={false}
                searchs={false}
              />
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}
export default Activation;
